import '../stylesheets/event_autocomplete_search';
import "@fortawesome/fontawesome-free/css/all.css";

import { createApp } from 'vue';
import Autocomplete from '../components/autocomplete.vue';
import { EventAutocompleteSearchComponent } from './event_autocomplete_search_component';

document.addEventListener('DOMContentLoaded', () => {
  const app = createApp({
    components: {
      Autocomplete
    },

    ...EventAutocompleteSearchComponent
  });
  app.mount('#event_autocomplete_search_app');
});
